export const CREDITS_LIST = 'CREDITS_LIST'
export const TEAMS_LIST = 'TEAMS_LIST'
